import { Environment } from '@src/config/environment';

export function getThumbUrl(fileId: string): string {
  return `${Environment.DIRECTUS_API_URL}/assets/${fileId}?width=100&height=100&fit=inside&quality=35`;
}
